import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Form, Label } from 'semantic-ui-react';

import { useForm } from '../../../hooks';

import ComponentType1Form from './ComponentType1Form';
import ComponentType2Form from './ComponentType2Form';
import ComponentType3Form from './ComponentType3Form';
import ComponentType4Form from './ComponentType4Form';
import ComponentType5Form from './ComponentType5Form';
import ComponentType6Form from './ComponentType6Form';
import ComponentType7Form from './ComponentType7Form';
import ComponentType8Form from './ComponentType8Form';

import styles from '../SettingDashboard.module.scss';

const ComponentForm = React.memo(
  ({ devices, factories, items, component, isSubmitting, onUpdate, onClose }) => {
    const [t] = useTranslation();

    const [errorMessage, setErrorMessage] = useState([]);
    const defaultData1 = {
      id: component.id || 0,
      dataType: component.dataType, // 'daily',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      interval: component.interval,
      itemName: component.itemName,
      position: component.position,
      time: component.time,
      unitName: component.unitName,
      deviceIds: component.deviceIds ? component.deviceIds.split(',') : [],
      factoryIds: component.factoryIds ? component.factoryIds.split(',') : [],
      decimalPoint: component.decimalPoint,
      title: component.title,
    };

    const defaultData2 = {
      id: component.id || 0,
      dataType: 'realtime',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      itemNames: component.itemNames ? component.itemNames.split(',') : [],
      position: component.position,
      deviceId: component.deviceId,
    };

    const defaultData3 = {
      id: component.id || 0,
      dataType: 'realtime',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      itemNames: component.itemNames ? component.itemNames.split(',') : [],
      position: component.position,
      deviceId: component.deviceId,
    };

    const defaultData4 = {
      id: component.id || 0,
      dataType: 'daily',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      position: component.position,
      deviceId: component.deviceId,
      decimalPoint: component.decimalPoint,
      items: component.items || [],
      size: component.size,
    };

    const defaultData5 = {
      id: component.id || 0,
      dataType: 'daily',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      item: component.item || {},
      position: component.position,
      deviceIds: component.deviceIds ? component.deviceIds.split(',') : [],
      decimalPoint: component.decimalPoint,
    };

    const defaultData6 = {
      id: component.id || 0,
      dataType: 'realtime',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      itemName: component.itemName,
      position: component.position,
      min: component.min,
      max: component.max,
      deviceId: component.deviceId,
    };

    const defaultData7 = {
      id: component.id || 0,
      dataType: 'daily',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      itemName: component.itemName,
      position: component.position,
      unitName: component.unitName,
      deviceIdsGroup: component.deviceIdsGroup || [],
      decimalPoint: component.decimalPoint,
    };

    const defaultData8 = {
      id: component.id || 0,
      dataType: 'ymd',
      type: component.component.replace('type', ''),
      description: component.description,
      empty: component.empty,
      title: component.title,
      interval: component.interval,
      itemNames: component.itemNames ? component.itemNames.split(',') : [],
      position: component.position,
      deviceId: component.deviceId,
    };

    const [data1, handleFieldChange1] = useForm(() => ({
      ...defaultData1,
    }));

    const [data2, handleFieldChange2] = useForm(() => ({
      ...defaultData2,
    }));

    const [data3, handleFieldChange3] = useForm(() => ({
      ...defaultData3,
    }));

    const [data4, handleFieldChange4] = useForm(() => ({
      ...defaultData4,
    }));

    const [data5, handleFieldChange5] = useForm(() => ({
      ...defaultData5,
    }));

    const [data6, handleFieldChange6] = useForm(() => ({
      ...defaultData6,
    }));

    const [data7, handleFieldChange7] = useForm(() => ({
      ...defaultData7,
    }));

    const [data8, handleFieldChange8] = useForm(() => ({
      ...defaultData8,
    }));

    const typesOptions = [
      { key: 1, value: '1', text: 'Type 1' },
      { key: 2, value: '2', text: 'Type 2' },
      { key: 3, value: '3', text: 'Type 3' },
      { key: 4, value: '4', text: 'Type 4' },
      { key: 5, value: '5', text: 'Type 5' },
      { key: 6, value: '6', text: 'Type 6' },
      { key: 7, value: '7', text: 'Type 7' },
      { key: 8, value: '8', text: 'Type 8' },
    ];

    const [typeComponent, setTypeComponent] = useState(
      component.component ? component.component.replace('type', '') : '1',
    );

    const getTypeComponent = (event, { value }) => {
      setTypeComponent(value);
    };

    const [empty, setEmpty] = useState(false);

    const handleFieldEmptyChange = (e, { checked }) => {
      setEmpty(checked);
    };

    const [fieldItems, setFieldItems] = useState([]);
    const [fieldItem, setFieldItem] = useState({});
    const [fieldDeviceIdsGroup, setFieldDeviceIdsGroup] = useState([]);

    const handleFieldItemsChange = (dataValue) => {
      setFieldItems(dataValue);
    };

    const handleFieldItemChange = (dataValue) => {
      setFieldItem(dataValue);
    };

    const handleFieldDeviceIdsGroupChange = (dataValue) => {
      setFieldDeviceIdsGroup(dataValue);
    };

    const handleSubmit = useCallback(() => {
      let cleanData = {};

      const isError = [];
      switch (typeComponent) {
        case '2':
          cleanData = {
            ...data2,
            type: typeComponent,
            empty,
            itemNames: data2.itemNames.toString(),
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.itemNames) {
            isError.push('itemNames');
          }
          if (!cleanData.deviceId) {
            isError.push('deviceId');
          }
          break;
        case '3':
          cleanData = {
            ...data3,
            type: typeComponent,
            empty,
            itemNames: data3.itemNames.toString(),
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.itemNames) {
            isError.push('itemNames');
          }
          if (!cleanData.deviceId) {
            isError.push('deviceId');
          }
          break;
        case '4':
          cleanData = {
            ...data4,
            type: typeComponent,
            empty,
            items: fieldItems,
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.decimalPoint) {
            isError.push('decimalPoint');
          }
          if (!cleanData.deviceId) {
            isError.push('deviceId');
          }
          if (!cleanData.size) {
            isError.push('size');
          }
          break;
        case '5':
          cleanData = {
            ...data5,
            type: typeComponent,
            empty,
            item: fieldItem,
            deviceIds: data5.deviceIds.toString(),
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.decimalPoint) {
            isError.push('decimalPoint');
          }
          if (!cleanData.deviceIds) {
            isError.push('deviceIds');
          }
          break;
        case '6':
          cleanData = {
            ...data6,
            type: typeComponent,
            empty,
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.itemName) {
            isError.push('itemName');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.deviceId) {
            isError.push('deviceId');
          }
          if (cleanData.min === '') {
            isError.push('min');
          }
          if (cleanData.max === '') {
            isError.push('max');
          }
          break;
        case '7':
          cleanData = {
            ...data7,
            type: typeComponent,
            empty,
            deviceIdsGroup: fieldDeviceIdsGroup,
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.itemName) {
            isError.push('itemName');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.unitName) {
            isError.push('unitName');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.decimalPoint) {
            isError.push('decimalPoint');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          break;
        case '8':
          cleanData = {
            ...data8,
            type: typeComponent,
            empty,
            itemNames: data8.itemNames.toString(),
          };
          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.itemNames) {
            isError.push('itemNames');
          }
          if (!cleanData.deviceId) {
            isError.push('deviceId');
          }
          break;
        default:
          cleanData = {
            ...data1,
            type: typeComponent,
            empty,
            deviceIds: data1.deviceIds.toString(),
            factoryIds: data1.factoryIds.toString(),
          };

          if (cleanData.position === 0) {
            isError.push('position');
          }
          if (!cleanData.dataType) {
            isError.push('dataType');
          }
          if (!cleanData.time) {
            isError.push('time');
          }
          if (!cleanData.title) {
            isError.push('title');
          }
          if (!cleanData.description) {
            isError.push('description');
          }
          if (!cleanData.interval) {
            isError.push('interval');
          }
          if (!cleanData.itemName) {
            isError.push('itemName');
          }
          if (!cleanData.unitName) {
            isError.push('unitName');
          }
          if (!cleanData.decimalPoint) {
            isError.push('decimalPoint');
          }
          if (!cleanData.deviceIds) {
            isError.push('deviceIds');
          }
          if (!cleanData.factoryIds) {
            isError.push('factoryIds');
          }
      }

      setErrorMessage(isError);
      if (isError.length > 0) return;
      onUpdate(cleanData);
      onClose();
    }, [
      data1,
      data2,
      data3,
      data4,
      data5,
      data6,
      data7,
      data8,
      typeComponent,
      empty,
      fieldItems,
      fieldItem,
      fieldDeviceIdsGroup,
      onUpdate,
      onClose,
    ]);

    const formContent = (componentType) => {
      switch (componentType) {
        case '2':
          return (
            <ComponentType2Form
              data={data2}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange2}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
        case '3':
          return (
            <ComponentType3Form
              data={data3}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange3}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
        case '4':
          return (
            <ComponentType4Form
              data={data4}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange4}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              onChangeItemsField={handleFieldItemsChange}
              isError={errorMessage}
            />
          );
        case '5':
          return (
            <ComponentType5Form
              data={data5}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange5}
              devices={devices}
              items={items}
              onChangeItemField={handleFieldItemChange}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
        case '6':
          return (
            <ComponentType6Form
              data={data6}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange6}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
        case '7':
          return (
            <ComponentType7Form
              data={data7}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange7}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              onChangeDeviceIdsGroupField={handleFieldDeviceIdsGroupChange}
              isError={errorMessage}
            />
          );
        case '8':
          return (
            <ComponentType8Form
              data={data8}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange8}
              devices={devices}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
        default:
          return (
            <ComponentType1Form
              data={data1}
              isSubmitting={isSubmitting}
              onChangeField={handleFieldChange1}
              devices={devices}
              factories={factories}
              items={items}
              onChangeEmptyField={handleFieldEmptyChange}
              isError={errorMessage}
            />
          );
      }
    };

    return (
      <Form onSubmit={handleSubmit}>
        <Form.Field>
          <Label>{t('common.components.type')}</Label>
          <Form.Select
            className={styles.field}
            placeholder={t('common.selectDeviceModel')}
            search
            fluid
            selection
            value={typeComponent}
            options={typesOptions}
            onChange={getTypeComponent}
          />
        </Form.Field>
        {formContent(typeComponent)}
        <Button color="green" icon="checkmark" content={t('action.save')} />
        <div className="clearBoth" />
      </Form>
    );
  },
);

ComponentForm.propTypes = {
  component: PropTypes.objectOf(PropTypes.any),
  isSubmitting: PropTypes.bool.isRequired,
  onUpdate: PropTypes.func.isRequired,
  devices: PropTypes.arrayOf(PropTypes.any).isRequired,
  factories: PropTypes.arrayOf(PropTypes.any).isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  onClose: PropTypes.func.isRequired,
};

ComponentForm.defaultProps = {
  component: undefined,
};

export default ComponentForm;
